import styled from "styled-components";
import DesignConstants from "../../../../../../constants/DesignConstants";
import StyledButtonWithIcon from "../../../../../../basic/styledButtonWithIcon/StyledButtonWithIcon";

const xxs = parseFloat(DesignConstants.SPACES.XXS);
const xs = parseFloat(DesignConstants.SPACES.XS);
const result = xxs + xs + "rem";

export const InputWrapper = styled.div`
    width: 100%;
    padding: ${result} ${DesignConstants.SPACES.M};
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    background: white;
`;

export const ButtonWithIcon = styled(StyledButtonWithIcon)`
    display: inline-block;
    align-self: start;

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        display: block;
        width: 100%;
        height: auto;
        padding-top: ${DesignConstants.SPACES.XS};
        padding-bottom: ${DesignConstants.SPACES.XS};
        text-align: left;

        div {
            white-space: normal;
            text-align: left;
        }
    }
`;
